/**
 * SERBEST FATURA KAYIT ISLEMLERI
 *
 * fatura/serbestfatura.vue ve fatura/faturakopya.vue kaydet, guncelle, iade kaydi, fatura
 * no/tarih degistirme ve silme islemlerini ayri ayri tasiyordu. faturakopya eski bir kopya
 * oldugu icin ayrismislardi: API'ye gondermeden once yuvarlama yapmiyordu, mesajlari sabit
 * Turkce metindi ve iade kaydi hata verince yukleme penceresi acik kaliyordu. Buradaki surum
 * SERBESTFATURA'nin surumudur. Sonra iki sayfa da birlesti: faturakopya artik serbestfatura.vue'nun
 * kopya modu (router.js meta.kopya).
 *
 * Fonksiyonlar sayfanin METODU olarak calisir (`this` = sayfa). Sayfa methods'a kaydeder:
 *
 *     const islemler = faturaIslemleri.metotlar()
 *     methods: { Kaydet: islemler.Kaydet, FaturaGuncelle: islemler.FaturaGuncelle, ... }
 *
 * Sayfada bulunmasi gereken durum ve metotlar:
 * ChangeFaturaNo, ChangeTarih, dialogdegistir, dialogsor, faturaGetir, guncellebuton,
 * iadedialog, islemturu, kayitliModaGec, loadingdialog, nefaturasi, satiritems, SerbestFatura,
 * snackbar, text1, tumAlanlariDogrula, yazdirbtngoster; ayrica $router.
 *
 * Butonlar kaydetbutonu (CLAUDE.md): her islem istegin Promise'ini DONDURUR, buton cevabi
 * bekleyip pasif kalir. Cift tiklama kilidi bilesende; burada kilit bayragi tutulmaz.
 */

import tool from '@/components/app/coper/tools.js'
import hesap from './faturaHesap.js'
import VueRouter from 'vue-router'

function round2(val) {
    var num = parseFloat(val)
    if (isNaN(num)) return val
    return Number(num.toFixed(2))
}

function roundInvoiceTutarlar(fatura) {
    if (fatura.Tutarlar) {
        fatura.Tutarlar.ToplamTutar = round2(fatura.Tutarlar.ToplamTutar)
        fatura.Tutarlar.Iskonto = round2(fatura.Tutarlar.Iskonto)
        fatura.Tutarlar.FaturaToplam = round2(fatura.Tutarlar.FaturaToplam)
        fatura.Tutarlar.Kdv = round2(fatura.Tutarlar.Kdv)
        fatura.Tutarlar.TevkifatKdv = round2(fatura.Tutarlar.TevkifatKdv)
    }

    if (Array.isArray(fatura.Detay)) {
        fatura.Detay.forEach(function (satir) {
            // Birim fiyat 4 haneye: veritabanindaki money sutunu 4 tutuyor,
            // 2'ye yuvarlamak kullanicinin girdigi hassasiyeti bosuna kesiyordu.
            satir.BirimFiyat = hesap.round4(satir.BirimFiyat)
            satir.Tutar = round2(satir.Tutar)
            // Doviz tutari 2 hane: e-faturada doviz tutarlari noktadan sonra
            // 2 hane olmak ZORUNDA. Yuvarlama hesap.round2 ile -- buradaki
            // yerel round2 toFixed tabanli ve yarim degerlerde sapiyor
            // (7,805 -> 7,80; SQL ROUND ve e-fatura beklentisi 7,81).
            satir.DovizTutar = hesap.round2(satir.DovizTutar)
            satir.IskontoTutar = round2(satir.IskontoTutar)
            satir.KdvTutar = round2(satir.KdvTutar)
            satir.TevkifatDetayTutar = round2(satir.TevkifatDetayTutar)
        })
    }
}

/**
 * Sunucunun ResponseMessage'i duz metin (orn. "Kayıt Edildi."). Ceviri anahtariysa cevrilir,
 * degilse oldugu gibi gosterilir. Onceden her mesaj $t'ye anahtar diye veriliyordu; vue-i18n her
 * seferinde konsola "Cannot translate the value of keypath" uyarisi basiyordu.
 */
function sunucuMesaji(mesaj) {
    return mesaj && typeof this.$te === 'function' && this.$te(mesaj) ? this.$t(mesaj) : mesaj
}

/**
 * Dovizli faturada kur yoksa (0 ya da bos) kayit / guncelleme sunucuya gitmez: API doviz
 * tutarini kura bolerek hesapliyor. Kur bulunamayinca ekran artik 1 yazmiyor, alani bos
 * birakiyor (faturakalemleri kurgetir). Kur yoksa uyari gosterilir ve true doner.
 */
function kurEksik() {
    if (this.SerbestFatura.Dovizli === true && !(parseFloat(this.SerbestFatura.Kur) > 0)) {
        this.text1 = this.$t('Exchange-Rate-Not-Found')
        this.snackbar = true
        return true
    }
    return false
}

/**
 * Basarili kayittan (Kaydet, iade kaydi, guncellenen iade, no / tarih degistirme) sonra kayitli
 * faturayi AYNI ekranda acar: adres kayitli faturaninkine cevrilir (tarayici gecmisine yeni kayit
 * eklenmeden) ve sayfa kayitliModaGec ile guncelleme moduna gecip faturayi okur. Kopya adresinden
 * de ayni bilesenin serbestfatura adresine gecilir. Onceden adres window.open ile degistirilip
 * 5 sn sonra sayfa bastan yukleniyordu; no / tarih degistirmeden sonra da fatura listesine
 * gidiliyordu.
 */
function kayitliFaturayiAc() {
    var gelen = this.nefaturasi == 'gelen'
    var adres = {
        path: '/fatura/serbestfatura/id',
        query: {
            ft: String(this.SerbestFatura.Tarih),
            ck: String(this.SerbestFatura.Cari.Kod),
            et: 'SF',
            es: String(this.SerbestFatura.FaturaSeri),
            en: String(this.SerbestFatura.FaturaNo),
            ner: 'X',
            // Gelen evrak adresi gelen fatura listesindekiyle ayni: sb=false.
            sb: String(!gelen),
            islem: gelen ? 'gelenevrak' : 'get',
        },
    }
    return this.$router.replace(adres).then(
        () => this.kayitliModaGec(),
        (hata) => {
            // Kayitli iade faturasi guncellenince adres cogu zaman AYNI kalir ve vue-router ayni
            // adrese gecisi NavigationDuplicated ile reddeder; fatura yine okunur. Onceden bu dal
            // bostu: fatura okunmuyor, yukleme penceresi acik kaliyordu.
            if (VueRouter.isNavigationFailure(hata, VueRouter.NavigationFailureType.duplicated)) {
                return this.kayitliModaGec()
            }
            // Gecis kesildi (orn. oturum dustu ve girise yonlendirildi, ya da kullanici baska
            // sayfaya gecti): sayfa zaten ayriliyor, kayitli moda gecilmez.
        })
}

function iadeFaturaKayit() {
    // Buton kaydetbutonu: cift tiklama kilidi bilesende; istegin Promise'i ona DONDURULUR (CLAUDE.md).

    if (this.$refs.formiade.validate()) {
        this.loadingdialog = true;
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));
        this.SerbestFatura.SirketKodu = credentials.SirketKodu
        this.SerbestFatura.Detay = this.satiritems
        roundInvoiceTutarlar(this.SerbestFatura)
        // API `ToplamTutar`i KDV DAHIL sayiyor (bkz. apiIcinFatura).
        var params = hesap.apiIcinFatura(this.SerbestFatura)

        return tool.api_post(this, 'Invoice/FreeInvoiceAdd', params).then((response) => {
            if (response.body.Status === true) {
                this.iadedialog = false
                this.text1 = sunucuMesaji.call(this, response.body.ResponseMessage)
                this.snackbar = true
                return kayitliFaturayiAc.call(this)

            } else {
                 this.text1 = sunucuMesaji.call(this, response.body.ResponseMessage)
                this.snackbar = true
                 this.loadingdialog = false;
            }
        }, (response) => {
            // Sunucunun gercek aciklamasi (duz metin govde, 429 sinirlama mesaji vb.).
            this.text1 = tool.HataMesajiCoz(response, this.$t.bind(this))
            this.snackbar = true
            this.loadingdialog = false;
        })

    }

}

//kaydetme işlemi
function Kaydet() {
    // Buton kaydetbutonu: cift tiklama kilidi bilesende; istegin Promise'i ona DONDURULUR (CLAUDE.md).

    if (kurEksik.call(this)) { return }

    var islemok = false

    if (this.nefaturasi == 'serbest') {

        if (parseFloat(this.SerbestFatura.Tutarlar.FaturaToplam) > 0) {
            islemok = true
        } else {
            this.text1 = this.$t('You-cannot-enter-invoices-with-amounts-0-and-below.')
            this.snackbar = true
            islemok = false
        }
    }

    if (this.nefaturasi == 'gelen') {
        islemok = true

        var yedekEFaturaShowID = {
            EFaturaID: null,
            EFaturaGuid: null,
            FaturaStatus: null,
            PdfID: null,
            DizaynID: null,
            XsltID: null
        }
        this.SerbestFatura.EFaturaShowID = yedekEFaturaShowID
    }

    if (islemok == true) {

        return this.tumAlanlariDogrula().then((result) => {

            if (this.SerbestFatura.EFaturaShowID.DizaynID != 0) {

                if (result) {

                    if (this.satiritems.length > 0) {

                        if (this.nefaturasi == 'gelen') {
                            this.SerbestFatura.Serbest = false
                        } else {
                            this.SerbestFatura.Serbest = true
                        }

                        if (this.SerbestFatura.FaturaTip == 0) {

                            this.SerbestFatura.IadeFaturaBilgi.IstinadenFaturaTarihi = null
                            this.SerbestFatura.IadeFaturaBilgi.IstinadenFaturaSeri = null
                            this.SerbestFatura.IadeFaturaBilgi.IstinadenFaturaNo = null
                            this.SerbestFatura.IadeFaturaBilgi.IadeNedeni = null

                            var credentials = JSON.parse(window.localStorage.getItem('credentials'));
                            this.SerbestFatura.SirketKodu = credentials.SirketKodu
                            this.SerbestFatura.Detay = this.satiritems
                            roundInvoiceTutarlar(this.SerbestFatura)
                            // API `ToplamTutar`i KDV DAHIL sayiyor (bkz. apiIcinFatura).
                            var params = hesap.apiIcinFatura(this.SerbestFatura)
                            this.loadingdialog = true;

                            return tool.api_post(this, 'Invoice/FreeInvoiceAdd', params).then((response) => {
                                if (response.body.Status === true) {
                                    this.text1 = sunucuMesaji.call(this, response.body.ResponseMessage)
                                    this.snackbar = true
                                    // Kayitli modda Kaydet gizleniyor; Promise kayitli fatura okununca cozulur.
                                    return kayitliFaturayiAc.call(this)

                                } else {
                                     this.text1 = sunucuMesaji.call(this, response.body.ResponseMessage)
                                    this.snackbar = true
                                    this.loadingdialog = false;
                                }
                            }, (response) => {
                                // Sunucunun gercek aciklamasi (duz metin govde, 429 sinirlama mesaji vb.).
                                this.text1 = tool.HataMesajiCoz(response, this.$t.bind(this))
                                this.snackbar = true
                                this.loadingdialog = false;
                            })

                        } else {
                            this.iadedialog = true
                            // Istinaden fatura, iadenin dayandigi SATIS faturasi: kullanici girer, iade
                            // penceresi zorunlu tutuyor. Onceden iade faturasinin KENDI tarih / seri /
                            // no'suyla dolduruluyordu (yanlis referans) ve her Kaydet'te girilen neden
                            // siliniyordu.
                             this.loadingdialog = false;

                        }

                    } else {
                        this.text1 = this.$t('Line-Entry')
                        this.snackbar = true
                        this.loadingdialog = false;
                    }
                } else {
                    this.text1 = this.$t('Please-fill-in-the-required-fields.')
                    this.snackbar = true
                    this.loadingdialog = false;
                }
            } else {
                this.text1 = this.$t('Please-select-invoice-design')
                this.snackbar = true
                this.loadingdialog = false;
            }

        })
    }
}

function FaturaGuncelle() {
    // Buton kaydetbutonu: cift tiklama kilidi bilesende; istegin Promise'i ona DONDURULUR (CLAUDE.md).

    if (kurEksik.call(this)) { return }

    // Guncellenebilir fatura turu mu? (Once iki ayri if/else vardi ve
    // ikincinin else'i birincinin sonucunu eziyordu; asagidaki
    // `if (control = true)` de bir ATAMA oldugu icin blok her zaman
    // calisiyordu. Iki hata birbirini goturuyordu.)
    var control = (this.nefaturasi == 'serbest' || this.nefaturasi == 'gelen')

    if (this.nefaturasi == 'gelen') {
        var yedekEFaturaShowID = {
            EFaturaID: null,
            EFaturaGuid: null,
            FaturaStatus: null,
            PdfID: null,
            DizaynID: null,
            XsltID: null
        }
        this.SerbestFatura.EFaturaShowID = yedekEFaturaShowID
    }

    if (control) {
        return this.tumAlanlariDogrula().then((result) => {

            if (result) {

                if (this.satiritems.length > 0) {

                    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

                    if (this.nefaturasi == 'gelen') {
                        this.SerbestFatura.Serbest = false
                    } else {
                        this.SerbestFatura.Serbest = true
                    }

                    this.SerbestFatura.SirketKodu = credentials.SirketKodu

                    this.SerbestFatura.Update = true

                    this.SerbestFatura.Detay = this.satiritems

                    roundInvoiceTutarlar(this.SerbestFatura)

                    // API `ToplamTutar`i KDV DAHIL sayiyor (bkz. apiIcinFatura).
                    var params = hesap.apiIcinFatura(this.SerbestFatura)

                    if (this.SerbestFatura.FaturaTip == 0) {
                         this.loadingdialog = true;
                        return tool.api_post(this, 'Invoice/FreeInvoiceAdd', params).then((response) => {
                            if (response.body.Status === true) {
                                 this.text1 = sunucuMesaji.call(this, response.body.ResponseMessage)
                                this.snackbar = true

                                return this.faturaGetir()

                            } else {
                                 this.text1 = sunucuMesaji.call(this, response.body.ResponseMessage)
                                this.snackbar = true
                                this.loadingdialog = false;

                            }
                        }, (response) => {
                            // Sunucunun gercek aciklamasi (duz metin govde, 429 sinirlama mesaji vb.).
                            this.text1 = tool.HataMesajiCoz(response, this.$t.bind(this))
                            this.snackbar = true
                            this.loadingdialog = false;
                        })

                    } else {
                        this.iadedialog = true

                    }

                } else {
                    this.text1 = this.$t('Line-Entry')
                    this.snackbar = true
                }

            } else {
                this.text1 = this.$t('Please-fill-in-the-required-fields.')
                this.snackbar = true
            }

        })

    }
}

function faturabilgidegistir() {
    // "Degistir" butonu kaydetbutonu: cift tiklama kilidi bilesende; buton cevabi
    // bekleyebilsin diye istegin Promise'i DONDURULUR. Metotta ayrica kilit bayragi
    // tutulmaz (CLAUDE.md).
    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    // Numara (islemturu 0) ve tarih (1) ayni istegi atiyor; farkli olan yalnizca
    // ChangeInfo ve basarida sayfada guncellenen alan.
    var changeparams = null
    if (this.islemturu == 0 && this.ChangeFaturaNo != null && this.ChangeFaturaNo != '') {
        changeparams = {
            ChangeType: false, // false : numara, true : tarih
            YeniEvrakno: this.ChangeFaturaNo,
            YeniTarih: null
        }
    } else if (this.islemturu == 1 && this.ChangeTarih != null && this.ChangeTarih != '') {
        changeparams = {
            ChangeType: true, // false : numara, true : tarih
            YeniEvrakno: null,
            YeniTarih: this.ChangeTarih
        }
    }

    if (changeparams == null) {
        // Bos numara / tarih ya da secilmemis islem turu: istek gitmez.
        this.text1 = this.$t('Please-fill-in-the-required-fields.')
        this.snackbar = true
        return
    }

    var params = {
        SirketKodu: credentials.SirketKodu,
        Tarih: this.SerbestFatura.Tarih,
        CariKod: this.SerbestFatura.Cari.Kod,
        EvrakTipi: null,
        EvrakSeri: this.SerbestFatura.FaturaSeri,
        Evrakno: this.SerbestFatura.FaturaNo,
        Nereden: 'X',
        // Gelen evrak (alis faturasi) Serbest=false. Sunucu serbest faturaya ozel adimlari
        // (FaturaBilgiDetay, e-fatura, odeme bilgisi) bu bayrakla seciyor; sabit true iken gelen
        // evrakin numara/tarih degisikligi sunucuda istisnayla kiriliyordu.
        Serbest: this.nefaturasi != 'gelen',
        Opsiyonlar: {
            IskontoBas: false,
            DovizBas: false,
            OdemeBas: false,
            YolcuBas: false,
            CariBasma: false,
            Deleted: false,
        },
        ChangeInfo: changeparams,
        FaturaUnique: this.SerbestFatura.FaturaUnique
    }

    return tool.api_post(this, 'Invoice/FreeInvoiceChange', params).then((response) => {
        // Basarili da olsa reddedilse de sunucunun mesaji gosterilir (orn. "Bu fatura
        // onaylanmis. Numarasini degistiremezsiniz.").
        this.text1 = sunucuMesaji.call(this, response.body.ResponseMessage)
        this.snackbar = true

        if (response.body.Status === true) {
            if (changeparams.ChangeType) {
                this.SerbestFatura.Tarih = this.ChangeTarih
            } else {
                this.SerbestFatura.FaturaNo = this.ChangeFaturaNo
            }
            // Fatura ayni ekranda yeni numara / tarihle yeniden acilir (Kaydet'teki yol). Onceden
            // 1,5 sn sonra fatura listesine gidiliyordu.
            this.dialogdegistir = false
            return kayitliFaturayiAc.call(this)
        }
    }, (response) => {
        // Sunucunun gercek aciklamasi (duz metin govde, 429 sinirlama mesaji vb.).
        // Onceden response.statusText gosteriliyordu: 429'da bos snackbar, baglanti
        // yokken (status 0) govde okunurken hata.
        this.text1 = tool.HataMesajiCoz(response, this.$t.bind(this))
        this.snackbar = true
    })
}

function faturasil() {
    // Buton kaydetbutonu: cift tiklama kilidi bilesende; istegin Promise'i ona DONDURULUR (CLAUDE.md).

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var params = {
        SirketKodu: credentials.SirketKodu,
        Tarih: this.SerbestFatura.Tarih,
        CariKod: this.SerbestFatura.Cari.Kod,
        EvrakTipi: null,
        EvrakSeri: this.SerbestFatura.FaturaSeri,
        Evrakno: this.SerbestFatura.FaturaNo,
        Nereden: 'X',
        // Gelen evrak Serbest=false: sunucu varsa odeme bilgisini de siler, serbest faturaya ozel
        // FaturaBilgiDetay adimini atlar (SerbestFaturaDelete.cs).
        Serbest: this.nefaturasi != 'gelen',
        FaturaUnique:this.SerbestFatura.FaturaUnique,
    }

    return tool.api_post(this, 'Invoice/FreeInvoiceDelete', params).then((response) => {
        if (response.body.Status === true) {
             this.text1 = sunucuMesaji.call(this, response.body.ResponseMessage) + ' ' + this.$t('You-are-being-directed-to-the-invoice-list')
            this.snackbar = true
            this.dialogsor = false
            // Listeye yonlendirme beklenirken silinmis faturada Guncelle / silme / no-tarih
            // degistirme ve Yazdir kalmasin (onceden 5 sn boyunca tiklanabiliyordu).
            this.guncellebuton = false
            this.yazdirbtngoster = false

            if (this.$route.query.islem != "yenigelenevrak" && this.$route.query.islem != "gelenevrak") {
                setTimeout(function () {

                    var url = '#/fatura/faturalistesi'
                    window.open(url, '_self')
                }.bind(this), 5000)
            } else {
                setTimeout(function () {

                    var url = '#/fatura/gelenfaturalistesi'
                    window.open(url, '_self')
                }.bind(this), 5000)
            }

        } else {
             this.text1 = sunucuMesaji.call(this, response.body.ResponseMessage)
            this.snackbar = true
        }
    }, (response) => {
        // Sunucunun gercek aciklamasi (duz metin govde, 429 sinirlama mesaji vb.).
        this.text1 = tool.HataMesajiCoz(response, this.$t.bind(this))
        this.snackbar = true
        this.dialogsor = false
    })
}

/**
 * Sayfanin methods'una kaydedilecek islemler. Onceden iki secenek aliyordu (guncelleme sonrasi
 * adim, gelen evrak adresindeki sb); iki sayfa (serbestfatura, faturakopya) birlesince ikisi de
 * sabit kaldi: guncellemeden sonra fatura sayfanin faturaGetir'iyle okunur, gelen evrakta sb=false.
 */
export function metotlar() {
    return {
        Kaydet: Kaydet,
        FaturaGuncelle: FaturaGuncelle,
        iadeFaturaKayit: iadeFaturaKayit,
        faturabilgidegistir: faturabilgidegistir,
        faturasil: faturasil,
    }
}

export default {
    metotlar: metotlar,
}
